import { Component, DestroyRef, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MenuActionOrigin, MenuActionsService, Page, ProductService } from '@frontend/vanilla/core';
import { ProductMenuConfig, ProductMenuService } from '@frontend/vanilla/shared/product-menu';
import { combineLatest, filter } from 'rxjs';

import { ProductMenuComponent } from './product-menu.component';

@Component({
    imports: [ProductMenuComponent],
    selector: 'vn-product-menu-view',
    templateUrl: 'product-menu-view.html',
    styleUrls: ['../../../../../themepark/themes/whitelabel/components/product-menu/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProductMenuViewComponent implements OnInit {
    private productMenuService = inject(ProductMenuService);
    private productMenuConfig = inject(ProductMenuConfig);
    private menuActionService = inject(MenuActionsService);
    private page = inject(Page);
    private productService = inject(ProductService);
    private destroyRef = inject(DestroyRef);

    ngOnInit() {
        combineLatest([this.productMenuConfig.whenReady, this.productMenuService.initialized.pipe(filter((e: boolean) => e))])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                if (this.productService.isSingleDomainApp) {
                    return;
                }

                if (this.productMenuConfig.routerMode) {
                    this.productMenuService.openTab(this.page.product);
                } else {
                    this.menuActionService.invoke('gotoHome', MenuActionOrigin.BottomNav);
                }
            });
    }
}
